import { createFileRoute } from "@tanstack/react-router";
import { PresetManager } from "@/pages/3d/configuration/PresetManager";

export const Route = createFileRoute("/demo/3d/configuration/presets")({
  component: PresetManager,
});
